import { ObjectDefinition, OptimizelyProduct } from '../../types/DataSyncItem';
import { DataSyncObjectsStore } from './DataSyncObjectsStore';
import { directoryStore } from '../DirectoryStore';
import { ZipApi } from '../../lib/ZipApi';
import { observable } from 'mobx';
import { DestinationSchemaItem } from '../../types/Schema';
import { FieldDefinition } from '../../types/FieldDefinition';
import { convertSchemaV2ToObjectDefinition } from '../../lib/convertV2Schema';
import { showToasts } from '../../lib/toaster';

export default class DataSyncCrObjectsStore extends DataSyncObjectsStore {
  @observable private _destinationObjectList?: DestinationSchemaItem[];

  public getDestinationObjectList(): ObjectDefinition[] {
    if (!this._destinationObjectList) {
      return [];
    }
    return this._destinationObjectList.map((item) => {
      return {
        object_name: item.id,
        object_display_name: item.id || item.display_name,
        object_icon_url: '',
        fields: [],
      };
    });
  }

  public async getDestinationObjectFields(objectName: string): Promise<FieldDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId || !objectName) {
      return [];
    }

    const transientDestinationObject = this.getTransientDestinationObject();
    if (transientDestinationObject?.object_name === objectName) {
      return transientDestinationObject?.fields || [];
    }

    this.loading = true;
    try {
      const schema = await ZipApi.getDestinationSchema(
        directoryStore.trackerId, OptimizelyProduct.CR, this.instanceId, objectName
      );
      const objectDef = convertSchemaV2ToObjectDefinition(schema);
      if (objectDef?.fields) {
        return objectDef.fields;
      }
    } catch (error: any) {
      this.handleDestinationFetchError(error);
    } finally {
      this.loading = false;
    }

    return [];
  }

  protected handleDestinationFetchError(_error: any): void {
    showToasts([{
      intent: 'danger',
      message: 'Unable to fetch Content Recommendations schema, please try again later.',
    }]);
  }

  protected async fetchSourceObjectDefinitions(): Promise<ObjectDefinition[]> {
    throw new Error('Content Recommendations as source is not supported');
  }

  protected async fetchDestinationObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }

    const response = await ZipApi.listDestinationSchemas(
      directoryStore.trackerId, OptimizelyProduct.CR, this.instanceId
    );

    if (response) {
      this._destinationObjectList = response.schemas || [];
    }

    return this.getDestinationObjectList();
  }
}
